module.exports = __webpack_public_path__ + "static/Royale-ABOUTPAGE-KittenImage-ff5eb747c42372c534e17eb729ba9912.jpg";